import { FocusAreaCard } from "../../../utils";
import "./leadership.css";



const Leadership = ({title, data}) => {
  return (
    <div className="section-container bg-apna-blue">
      <div className="section-title-cont">
        <hr className="section-title-line" />
        <h3 className="section-title cl-white">{title}</h3>
      </div>
      <div className="card-holder">
        {data.map(({ image, name, title, text }) => {
          return (
            <FocusAreaCard
              title={title}
              image={image}
              description={text}
              name={name}
              height={'18.5rem'}
              leaders
            />
          );
        })}
      </div>
    </div>
  );
};

export default Leadership;
